var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress-bar-container"},[_c('div',{staticClass:"progress-bar",style:(_vm.animateProgress ? {} : { width: _vm.progressBarWidth }),attrs:{"id":"progress-bar"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }